import { handleError } from '../../../components/errors/errorHandling';
import { getFile } from '../../../services/file/FileService';

const useFile = (): any => {
  const downloadFile = async (fileId: string) => {
    try {
      const data = await getFile(fileId);
      const blobData = new Blob([data.data], { type: data.headers['content-type'] });
      const fileUrl = window.URL.createObjectURL(blobData);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', fileId.split('/')[2]);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      handleError(error);
    }
  };

  return { downloadFile };
};

export default useFile;
